import { render, staticRenderFns } from "./TelWind.vue?vue&type=template&id=14d5b783"
import script from "./TelWind.vue?vue&type=script&lang=js"
export * from "./TelWind.vue?vue&type=script&lang=js"
import style0 from "./TelWind.vue?vue&type=style&index=0&id=14d5b783&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports